<template>
  <div class="selects__wrap">
    <a-row type="flex">
      <a-col flex="1">
        <a-select v-model="requestObj.type" class="selects__item" :size="size">
          <a-select-option v-for="type of variablesType" :key="type.value" :value="type.value">
            {{ type.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col flex="0.5">
        <a-select v-model="requestObj.year" class="selects__item" :size="size">
          <a-select-option v-for="(year, idx) of variablesYear" :key="idx" :value="year">
            {{ year }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col flex="1">
        <a-select v-model="requestObj.month" class="selects__item" :size="size">
          <a-select-option
            v-for="isMonth of variablesMonth"
            :key="isMonth.value"
            :value="isMonth.value"
          >
            {{ isMonth.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col v-if="requestObj.type === 'primary_data_download'" flex="1">
        <a-select v-model="requestObj.source" class="selects__item" :size="size">
          <a-select-option v-for="(source, idx) of sources" :key="idx" :value="source.value">
            {{ source.title }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col v-if="requestObj.type === 'primary_data_download'" flex="1">
        <a-select v-model="requestObj.informationType" class="selects__item" :size="size">
          <a-select-option v-for="(type, idx) of informationTypes" :key="idx" :value="type.value">
            {{ type.title }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col flex="1">
        <a-select v-model="requestObj.status" class="selects__item" :size="size" style="padding: 0">
          <a-select-option
            v-for="status of variablesStatus"
            :key="status.value"
            :value="status.value"
          >
            {{ status.name }}
          </a-select-option>
        </a-select>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import TABLE_QUERY from '@/queries/table';

export default {
  name: 'Selects',

  props: {
    variablesType: {
      type: Array,
      required: true,
    },
    defaultDate: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      size: 'large',
      options: [],
      variablesYear: ['2019', '2020', '2021', '2022', '2023'],
      requestObj: {
        month: '02',
        status: 'all',
        year: '2022',
        type: '',
        source: '',
        informationType: '',
      },
      variablesStatus: [
        { name: 'Все загрузки', value: 'all' },
        { name: 'Только успешные', value: 'complete' },
        { name: 'Только с ошибками', value: 'error' },
        { name: 'Только текущие', value: 'running' },
      ],
      variablesMonth: [
        { name: 'Январь', value: '01' },
        { name: 'Февраль', value: '02' },
        { name: 'Март', value: '03' },
        { name: 'Апрель', value: '04' },
        { name: 'Май', value: '05' },
        { name: 'Июнь', value: '06' },
        { name: 'Июль', value: '07' },
        { name: 'Август', value: '08' },
        { name: 'Сентябрь', value: '09' },
        { name: 'Октябрь', value: '10' },
        { name: 'Ноябрь', value: '11' },
        { name: 'Декабрь', value: '12' },
      ],
    };
  },

  apollo: {
    sources: {
      ...TABLE_QUERY,
      loadingKey: 'loadingQueries',
      debounce: 250,
      variables() {
        return {
          type: 'DataSource',
          page: 0,
          pageSize: 999,
          filters: [],
          orders: [],
        };
      },
      update({ table }) {
        table = table.documents.map((el) => ({
          value: el.data.value,
          title: el.data.name,
        }));
        if (!this.requestObj.source) this.requestObj.source = table[0].value;
        return table;
      },
    },
    informationTypes: {
      ...TABLE_QUERY,
      loadingKey: 'loadingQueries',
      debounce: 250,
      variables() {
        return {
          type: 'InformationTypes',
          page: 0,
          pageSize: 999,
          filters: [],
          orders: [],
        };
      },
      update({ table }) {
        table = table.documents.map((el) => ({
          value: el.data.value,
          title: el.data.name,
        }));
        if (!this.requestObj.informationType) this.requestObj.informationType = table[0].value;
        return table;
      },
    },
  },
  watch: {
    requestObj: {
      handler(newValue) {
        this.$emit('requestFilterData', newValue);
      },
      deep: true,
    },

    defaultDate() {
      if (this.defaultDate) {
        this.requestObj.year = this.defaultDate[0];
        this.requestObj.month = this.defaultDate[1];
      }
    },
  },
  mounted() {
    this.requestObj.type = this.variablesType?.[0]?.value || '';
    this.requestObj.source = this.sources?.[0]?.value || '';
    this.requestObj.informationType = this.informationTypes?.[0].value || '';
    if (this.defaultDate) {
      this.requestObj.year = this.defaultDate[0];
      this.requestObj.month = this.defaultDate[1];
    }
  },
};
</script>

<style lang="scss">
.selects {
  &__wrap {
    width: 100%;
    margin-bottom: 10px;

    .ant-select,
    .ant-select-arrow-icon {
      color: $darkTextColor;
      font-weight: 600;
      font-size: 14px;
    }
    .ant-row-flex {
      margin: 5px -5px 0;

      .ant-col {
        padding: 0 5px;
      }
    }
  }

  &__item {
    //width: 25%;
    border: none;
    height: $filtersHeight;

    .ant-select-selection {
      border: none;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
